<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <div class="card-title">{{ $t('MySubmissions') }}</div>
            <v-card-text>
                <v-card-title>
                    <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('Search')" single-line hide-details />
                    <v-spacer />
                </v-card-title>
                <v-data-table :headers="headers" dense :items="mySubmissions" :search="search" class="mt-3">
                    <template v-slot:[`item.participationDate`]="{ item }">
                        {{ item.participationDate | formatDateTimeGregorian }}
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip small :color="item.status.toLowerCase()=='approved'? 'primarylight' :''" :class="`${item.status.toLowerCase()}`">{{ $t(item.status) }}</v-chip>
                    </template>
                    <template v-slot:[`item.options`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <router-link class="mx-3" :to="{ name: 'my-survey-results', params: { id: item.surveyId }}">
                                    <v-icon color="secondary" role="link" v-bind="attrs" v-on="on">mdi-list-box-outline</v-icon>
                                </router-link>
                            </template>
                            <span>{{ $t('Results') }}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import SurveyService from '@/services/SurveyService.js'

    export default {

        data() {
            return {
                search: '',
                loading: false,
                mySubmissions: [],
                headers: [
                    { text: this.$t('Id'), value: 'surveyId' },
                    { text: this.$t('Name'), value: 'name' },
                    { text: this.$t('Date'), value: 'participationDate' },
                    { text: this.$t('Status'), value: 'status' },
                    { text: this.$t('Options'), value: 'options', align: 'center' },
                ],
            }
        },

        created() {
            this.listSruveys()
        },
        methods: {
            listSruveys() {
                
                this.loading = true
                SurveyService.listMySubmissionsSurveys().then((res) => {
                    console.log('RES', res.data)
                    this.mySubmissions = res.data
                    this.activeSurveys = res.data.filter(x => x.active == true).length
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
        },
    }
</script>

<style>
    .v-chip.draft {
        background: #dedede;
    }

    .v-chip.pending {
        background: #ffaa2c;
    }

    .v-chip.approved {
        background: var(--v-secondary-base);
        color: #07706d
    }
</style>